import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

import 'modernizr'; // eslint-disable-line
import './bootstrap';
import './vendor/bootstrap';

import cart from './containers/cart';
import sentry from './sentry';

sentry();

const application = Application.start();
const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

if (document.querySelector('.js-cart')) {
  cart();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => {
        // Registration was successful
      })
      .catch((err) => {
        console.log('ServiceWorker registration failed: ', err); // eslint-disable-line
      });
  });
}
